import i18n from 'i18next';
import {initReactI18next} from 'react-i18next';
import translationEn from './translations/en-US.json';
import translationEs from './translations/es-ES.json';
import translationPt from './translations/pt-BR.json';
import {getLocale} from './helper';

const resources = {
  en: {
    translation: translationEn,
  },
  es: {
    translation: translationEs,
  },
  pt: {
    translation: translationPt,
  },
};

i18n.use(initReactI18next).init({
  // detection: { order: ['navigator'] },
  interpolation: {
    escapeValue: false,
  },
  lng: getLocale(),
  resources,
  transSupportBasicHtmlNodes: true,
});

export default i18n;



// WEBPACK FOOTER //
// ./src/i18n/i18n.js